var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.goal && _vm.initialized)?_c('ActivityResultForm',{ref:"form",attrs:{"activity-object":_vm.activity,"goal-object":_vm.goal,"attachment-option":_vm.attachmentOption},on:{"onClickSave":_vm.registerActivity,"onClickDraft":_vm.registerDraft}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }